export { default } from "./VerticalCalloutCardStatic";
